import { getDataRuleTenantList, queryDataRuleInstitution } from '@/common/services';
import { fetchAllTenantData } from '@/components/TenantTree/service';
import {
  addBanner,
  batchMoveArticle,
  changeArticleStatus,
  deleteArticle,
  deleteArticleGrounp,
  deleteBanner,
  deleteCompanyArticle,
  deletePopup,
  editArticleGroupSeq,
  fetchArticleDetail,
  fetchPopupDetail,
  getArticleGrounpTree,
  getArticleGroupSeqList,
  getArticleList,
  getArticleType,
  getBannerDetail,
  getBannerList,
  getOrgArticleGrounpTree,
  getPopupList,
  modifyBanner,
  moveArticle,
  moveGrounp,
  reqDetail,
  reqList,
  saveArticle,
  saveArticleGrounp,
  savePopup,
  switchBanner,
  updateArticleGrounp,
} from '../services/contentManage';
// import { zlbApiSopArticleArticleTypeGet } from '@/api/zlbSopContent';

export default {
  namespace: 'zoningContentManage',
  state: {
    tenantAllTree: [],
    dataRuleTenantList: [],
    articleTypeList: [],
    dataRuleOrgList: [],
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
      contentType: '4',
    },
    initSearchParams: {},
    list: {},
    detail: {},
  },
  effects: {
    *getTenantAllData({ payload }, { call, put }) {
      const result = yield call(fetchAllTenantData, payload);
      yield put({
        type: 'update',
        payload: {
          tenantAllTree: result || [],
        },
      });
    },
    // 获取有权限的租户列表
    *getDataRuleTenantList({ payload }, { call, put }) {
      const result = yield call(getDataRuleTenantList, payload);
      yield put({
        type: 'update',
        payload: {
          dataRuleTenantList: result?.tenants || [],
        },
      });
    },
    // 获取有权限的机构列表
    *queryDataRuleInstitution({ payload }, { call, put }) {
      const result = yield call(queryDataRuleInstitution, payload);
      yield put({
        type: 'update',
        payload: {
          dataRuleOrgList: result || [],
        },
      });

      return result;
    },
    // ==================== banner ===================================
    *getBannerList({ payload }, { call }) {
      const res = yield call(getBannerList, payload);
      return res;
    },

    *modifyBanner({ payload }, { call }) {
      const res = yield call(modifyBanner, payload);
      return res;
    },

    *addBanner({ payload }, { call }) {
      const res = yield call(addBanner, payload);
      return res;
    },

    *getBannerDetail({ payload }, { call }) {
      const res = yield call(getBannerDetail, payload);
      return res;
    },

    *deleteBanner({ payload }, { call }) {
      const res = yield call(deleteBanner, payload);
      return res;
    },

    *switchBanner({ payload }, { call }) {
      const res = yield call(switchBanner, payload);
      return res;
    },
    // ==================== 文章 ===================================
    // 获取文章类型列表
    *getArticleTypeList({ payload }, { call, put }) {
      const result = yield call(getArticleType, payload);
      yield put({
        type: 'update',
        payload: {
          articleTypeList: result || [],
        },
      });
    },
    *getArticleList({ payload }, { call }) {
      const reqService = getArticleList();
      const res = yield call(reqService, payload);
      return res;
    },
    *changeArticleStatus({ payload }, { call }) {
      const reqService = changeArticleStatus();
      const res = yield call(reqService, payload);
      return res;
    },
    *saveArticle({ payload }, { call }) {
      const res = yield call(saveArticle, payload);
      return res;
    },
    *fetchArticleDetail({ payload }, { call }) {
      const reqService = fetchArticleDetail();
      const res = yield call(reqService, payload);
      return res;
    },
    *deleteArticle({ payload }, { call }) {
      const reqService = deleteArticle();
      const res = yield call(reqService, payload);
      return res;
    },
    *fetchList({ payload }, { call }) {
      const result = yield call(reqList, payload);
      return result;
    },
    *detail({ payload }, { call, put }) {
      const result = yield call(reqDetail, payload);
      yield put({
        type: 'update',
        payload: {
          detail: result,
        },
      });
      return result;
    },
    *getOrgArticleGrounpTree({ payload }, { call }) {
      const result = yield call(getOrgArticleGrounpTree, payload);
      return result;
    },
    *deleteCompanyArticle({ payload }, { call }) {
      const res = yield call(deleteCompanyArticle, payload);
      return res;
    },

    // ==================== 弹窗 ===================================
    *getPopupList({ payload }, { call }) {
      const reqService = getPopupList();
      const res = yield call(reqService, payload);
      return res;
    },

    *savePopup({ payload }, { call }) {
      const reqService = savePopup();
      const res = yield call(reqService, payload);
      return res;
    },
    *fetchPopupDetail({ payload }, { call }) {
      const reqService = fetchPopupDetail();
      const res = yield call(reqService, payload);
      return res;
    },
    *deletePopup({ payload }, { call }) {
      const reqService = deletePopup();
      const res = yield call(reqService, payload);
      return res;
    },
    *getArticleGrounpTree({ payload }, { call }) {
      const res = yield call(getArticleGrounpTree, payload);
      return res;
    },
    *saveArticleGrounp({ payload }, { call }) {
      const res = yield call(saveArticleGrounp, payload);
      return res;
    },
    *updateArticleGrounp({ payload }, { call }) {
      const res = yield call(updateArticleGrounp, payload);
      return res;
    },
    *deleteArticleGrounp({ payload }, { call }) {
      const res = yield call(deleteArticleGrounp, payload);
      return res;
    },
    *moveGrounp({ payload }, { call }) {
      const res = yield call(moveGrounp, payload);
      return res;
    },
    *moveArticle({ payload }, { call }) {
      const res = yield call(moveArticle, payload);
      return res;
    },
    *batchMoveArticle({ payload }, { call }) {
      const res = yield call(batchMoveArticle, payload);
      return res;
    },
    *editArticleGroupSeq({ payload }, { call }) {
      const res = yield call(editArticleGroupSeq, payload);
      return res;
    },
    *getArticleGroupSeqList({ payload }, { call }) {
      const res = yield call(getArticleGroupSeqList, payload);
      return res;
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
